export default __webpack_public_path__ + "static/media/master_footer.d7c4ea0d.png";